import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { useAppSelector } from '../hook';
import { PackageRole } from '@types';

export type PackagesState = {
  role: PackageRole;
  dealershipGroupIds: string[];
  loaded: boolean;
};

const initialState: PackagesState = {
  role: null,
  dealershipGroupIds: [],
  loaded: false,
};

export const packagesSlice = createSlice({
  name: 'packages',
  initialState,
  reducers: {
    setPackageRole: (state, action: PayloadAction<{ role: PackageRole; dealershipGroupIds: string[] }>) => {
      state.role = action.payload.role;
      state.dealershipGroupIds = action.payload.dealershipGroupIds;
      state.loaded = true;
    },
    clearPackageRole: (state) => {
      state.role = null;
      state.dealershipGroupIds = [];
      state.loaded = false;
    },
  },
});

export const { setPackageRole, clearPackageRole } = packagesSlice.actions;

export const getPackageRole = (state: RootState) => state.packages.role;
export const getPackageRoleLoaded = (state: RootState) => state.packages.loaded;
export const getPackageDealershipGroupIds = (state: RootState) => state.packages.dealershipGroupIds;

export const usePackageRole = () => useAppSelector(getPackageRole);
export const usePackageRoleLoaded = () => useAppSelector(getPackageRoleLoaded);

export default packagesSlice.reducer;
